module.exports = __webpack_public_path__ + "img/p1.2a113990.png";